<template>
  <div :class="{myeditor:true,active:isActvie}">
    <quill-editor
      :value ="value"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
			@success="onSuccess($event)"
    ></quill-editor>
  </div>
</template> 
<script>
// 导入富文本的编辑配置
import { quillEditor } from "vue-quill-editor";
import config from '../assets/js/editorconfig.js'
export default {
  data() {
    return {
      editorOption: config,
      // value:null,
      isActvie:false
    };
  },
  props:{
    value:""
  },
  // model: {
  //   prop: 'valued',
  //   event: 'sub'
  // },
  // computed:{
  //   value(){
  //     return  this.valued
  //   }
  // },
  mounted(){
  },
  methods: {
    onEditorBlur() {
      //失去焦点事件
       this.isActvie = false
    },
    onEditorFocus() {
      //获得焦点事件
      this.isActvie = true
    },
    onEditorChange(data) {
      console.log(data,'change-----data')
      this.$emit('input',data.html)
    },
		onSuccess(data){
			console(data,'data')
		}
  }
};
</script>   
<style lang="css" >
.myeditor {
  background: #fff;
  text-align: left;
}
.myeditor .ql-toolbar{
  display: none;
}
.myeditor.active .ql-toolbar{
   display: block;
   border-radius: 5px 5px 0 0;
}
.ql-toolbar.ql-snow{
  padding: 2px 8px;
}
.myeditor.active .ql-toolbar{
   display: block;
   border-radius: 5px 5px 0 0;
}
.ql-container{
  border-radius: 5px;
}
.ql-editor{
  padding: 6px;
}
.myeditor.active .ql-container{
  border-radius: 0 0 5px 5px;
}
.ql-editor img{
	max-width: 60% !important;
}
/* .ql-editor{
    height: 100px;
} */
</style>


// WEBPACK FOOTER //
// src/components/editor.vue